<!-- <div cdkOverlayOrigin #commentsPopupAnchor class="comments-overlay-anchor"></div> -->
<div class="graphics-builder-form custom-graphics-builder">
    <form>
        <div class="d-flex flex-column">
            <!-- Top Header portion -->
            <div class="flex-head">
                <div class="d-flex row justify-content-between align-items-center">
                    <span class="builder-title">{{ isEditMode ? 'UPDATE QUERY' : 'ADD QUERY' }}</span>
                </div>
            </div>

            <!-- Content for Parameter Selection-->
            <div class="flex-body relative">
                <ng-container>
                    <div class="row">
                        <!-- Left Content -->
                        <div class="col-4 p-l-0 p-r-0">
                            <div class="col-12 graphics-side-bar-border p-l-24 p-r-0">
                                <div class="graphics-side-bar-configuration">
                                    <label class="lbl">Select Build Type</label>
                                    <div class="p-l-0 p-t-5" id="graphics-buildType">
                                        <div class="builder-type btn-group d-flex">
                                            <ng-container
                                                *ngFor="let option of buildTypeOptions; let first = first; let last = last;">
                                                <button class="btn w-100 level-btn-width"
                                                    (click)="onBuildTypeSelect(option)"
                                                    [disabled]='isGraphicsBuilderTypeChanged' tabindex="-1"
                                                    [ngClass]="{'btn-outline-primary color-primary pointer-event-none': (builderType === (option?.label)), 'btnGroup-leftstyle': first, 'btnGroup-rightstyle': last}"
                                                    value="{{option?.value}}"
                                                    id="{{'customParameterOptionBtn_' + option?.value}}">
                                                    {{option?.label}}
                                                </button>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <ng-template
                                        *ngIf="builderType && showscopeChangeWarning && !isGraphicsBuilderTypeChanged"
                                        [ngTemplateOutlet]="warningTplscope"
                                        [ngTemplateOutletContext]="{type: 'Build Type'}"></ng-template>

                                    <div [ngClass]="{'background-blur-overlay': showscopeChangeWarning}">
                                        <!-- custom query section -->
                                        <ng-container *ngIf="builderType == 'CUSTOM'">
                                            <div class="lbl p-t-10" id="graphics-custom-query-label">Type in your query
                                            </div>
                                            <div class="p-t-5">
                                                <textarea #queryElem class="query-textarea notranslate" autofocus
                                                    spellcheck="false" [(ngModel)]="haystackQuery"
                                                    (ngModelChange)="onCustomHaystackQueryEdited()"
                                                    placeholder="Enter your query here"
                                                    [ngModelOptions]="{standalone: true}" id="graphics-query-text-area">
                                                </textarea>
                                            </div>

                                            <div class="execute-query-btn-sec">
                                                <button class="text-uppercase excute-query-button"
                                                    [ngClass]="{'disabled': !haystackQuery?.length}"
                                                    (click)="executeCustomQuery(haystackQuery)"
                                                    id="graphics-execute-query-button">
                                                    <span class="cursor-pointer" *ngIf="!fetchingPoints">Execute
                                                        Query</span>
                                                    <span *ngIf="fetchingPoints">Executing ...</span>
                                                </button>
                                            </div>

                                        </ng-container>

                                        <!-- Builder select tag section -->
                                        <ng-container *ngIf="builderType == 'BUILDER'">
                                            <div class="p-t-12 p-b-12 point-selection-container"
                                                id="graphics-select-tags-section">
                                                <label class="lbl">Select Tags</label>
                                                <ng-select class="custom-select-point notranslate"
                                                    [ngClass]="{'update-line-height': !selectedTags?.length}"
                                                    (focus)="onInputFocus()" (change)="onInputBlur()"
                                                    (blur)="onInputBlur()" [items]="tagList" color="primary"
                                                    [multiple]="true" #tagSelectGraphics [(ngModel)]="selectedTags" name="selectedTags"
                                                    (remove)="onTagDeSelect($event)" (clear)="onTagsClear()"
                                                    (change)="onTagsChange($event)" [searchFn]="searchTag" addTagText=""
                                                    [clearOnBackspace]="true" [markFirst]="markFirst()"
                                                    dropdownPosition="bottom" [placeholder]="'Search For Tags'"
                                                    [clearSearchOnAdd]="false"
                                                    id="tags-dropdown">
                                                </ng-select>
                                            </div>
                                            <div *ngIf="builderType == 'BUILDER'">
                                                <div [ngClass]="{'disable-add-tag': !selectedTags?.length}"
                                                    [matMenuTriggerFor]="tagMenu" class="p-b-10 add-kvTag-label"
                                                    id="addKVTagsForCustomGrpahics">ADD TAG VALUE</div>
                                                <div>
                                                    <mat-menu #tagMenu="matMenu" class="tag-menu-custom-panel"
                                                        (closed)="onTagMenuClose()">
                                                        <div class="mat-menu-header"
                                                            (click)="$event.stopPropagation();">{{"KV Tags"}}</div>
                                                        <div *ngFor="let tag of kVTags; let i = index"
                                                            class="tag-menu-item">
                                                            <div class="tag-menu-container"
                                                                (click)="$event.stopPropagation();">
                                                                <div class="tag-name">{{tag.key}}</div>
                                                                <mat-form-field class="tag-input">
                                                                    <input matInput
                                                                        [value]="tag.value" placeholder="Type Value"
                                                                        (input)="setTagValue($event, tag)"
                                                                        (click)="$event.stopPropagation();" />
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </mat-menu>
                                                </div>
                                            </div>
                                        </ng-container>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Right Content -->
                        <div class="col-8 p-l-0 p-r-0" [ngClass]="{'background-blur-overlay': showscopeChangeWarning}">
                            <div class="builder-middle-content">
                                <!-- Builder matching points section -->
                                <ng-container>
                                    <div class="lbl">Matching Points</div>
                                    <div class="sub-lable">Hover on parameters to view the tags</div>
                                    <div id="graphics-matching-points" class="notranslate"
                                        [ngClass]="{'custom-matching-pts-ht': builderType == 'CUSTOM', 'builder-matching-pts-ht': builderType == 'BUILDER'}">
                                        <div class="m-t-6 builder-matching-pts-container"
                                            *ngIf="selectedTags.length || builderType == 'CUSTOM'"
                                            id="graphics-matching-points-container">
                                            <div *ngFor="let point of points"
                                                id="graphics-pointContainer_{{point?.id}}">
                                                <div class="point-description bgclor"
                                                    (mouseover)="pointHover($event, point)"
                                                    (mouseout)="pointHoverMouseOut(point)">
                                                    {{formatName(point?.displayName)}}
                                                    <div *ngIf="point.showTag && showTagTooltip"
                                                        [ngStyle]="toolTipPosition()"
                                                        class="tags-popup d-flex flex-wrap"
                                                        id="graphics-tagsPopup_{{point?.id}}">
                                                        <div *ngFor="let tag of point.tags; let last = last;"
                                                            id="graphics-tag_{{point?.pointId}}_{{tag?.pointId}}">
                                                            <div class="query-tag-text" *ngIf="tag.isQueryTag">
                                                                {{tag.tagName}}<span *ngIf="!last">,&nbsp;
                                                                </span>
                                                            </div>
                                                            <div class="nonQueryTag" *ngIf="!tag.isQueryTag">
                                                                {{tag.tagName}}<span *ngIf="!last">,&nbsp;</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="!points?.length && emptyLabel != ''"
                                                id="graphics-empty-points-label">
                                                <div class="point-description">{{emptyLabel}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                            <div class="action-buttons">


                                <!--Duplicate Button-->
                                <button
                                    class="btn btn-outline-primary color-primary text-uppercase  action-btn" (click)="addQuery()" [disabled]="!haystackQuery.length">{{ isEditMode ? 'UPDATE QUERY' : 'ADD QUERY' }}</button>

                                <!--Cancel Button-->
                                <button (click)="cancelDialog()"
                                    class=" btn btn-outline-primary color-primary text-uppercase action-btn">CANCEL</button>
                            </div>
                        </div>

                    </div>
                </ng-container>


            </div>

        </div>
    </form>


</div>

<!-- Warning Template -->
<ng-template #warningTplscope let-type="type">
    <div class="row align-items-start conditions-text" [ngClass]="{'m-t-12': type == 'Build Type'}">
        <div class="col-1">
            <i class="fa fa-exclamation-triangle color-primary fa-lg m-t-10 exclamation-icon" aria-hidden="true"></i>
        </div>
        <div class="col-11 p-l-10 pre-wrap warning-section">
            <p class="m-t-4 confirm-text">Are you sure you want to change <span id="graphics-type-placeholder">{{type |
                    lowercase}}</span> to
                <strong *ngIf="!isGraphicsBuilderTypeChanged"><span class="text-capitalize"
                        id="graphics-label-placeholder">{{tempscope?.label | lowercase }}</span>
                    ?</strong>
            </p>
            <p class="m-t-6 m-b-8 confirm-text">Changes you made so far will be lost.</p>
            <div class="d-flex justify-content-end action-btn-section">
                <button class="button-cta color-primary error-action-btn" id="graphics-change-conditon-cancel-btn"
                    (click)="showscopeChangeWarning = false">
                    CANCEL</button>
                <span class="seperator">|</span>
                <button class="button-cta btn-outline-primary color-primary error-action-btn"
                    id="graphics-change-conditon-change-btn" (click)="onBuildTypeSelect(tempscope, true)">
                    CHANGE</button>
            </div>
        </div>
    </div>
</ng-template>
